export default __webpack_public_path__ + "static/media/img--kitchen-1-dark.8df5b8e3.jpg";